export const COLUMN_NO = 'NO';
export const COLUMN_SENDER_NAME = 'SENDER_NAME';
export const COLUMN_SENDER_PHONE = 'SENDER_PHONE';
export const COLUMN_SENDER_ADDRESS = 'SENDER_ADDRESS';
export const COLUMN_SENDER_ADMIN_AREA = 'SENDER_ADMIN_AREA';
export const COLUMN_SENDER_ADDRESS_DETAIL = 'SENDER_ADDRESS_DETAIL';
export const COLUMN_RECEIVER_NAME = 'RECEIVER_NAME';
export const COLUMN_RECEIVER_PHONE = 'RECEIVER_PHONE';
export const COLUMN_RECEIVER_ADDRESS = 'RECEIVER_ADDRESS';
export const COLUMN_RECEIVER_ADMIN_AREA = 'RECEIVER_ADMIN_AREA';
export const COLUMN_RECEIVER_ADDRESS_DETAIL = 'RECEIVER_ADDRESS_DETAIL';
export const COLUMN_ITEM_WEIGHT = 'ITEM_WEIGHT';
export const COLUMN_PARCEL_SIZE = 'PARCEL_SIZE';
export const COLUMN_PARCEL = 'PARCEL';
export const COLUMN_COD = 'COD';
export const COLUMN_DELIVERY_INSTRUCTION = 'DELIVERY_INSTRUCTION';
export const COLUMN_REFERENCE_CODE = 'REFERENCE_CODE';
export const COLUMN_SERVICE_TYPE = 'SERVICE_TYPE';
export const COLUMN_VEHICLE_TYPE = 'VEHICLE_TYPE';
export const COLUMN_MULTI_STOP_BATCH = 'MULTI_STOP_BATCH';
export const COLUMN_MULTI_STOP_SEQUENCE_NUMBER = 'MULTI_STOP_SEQUENCE_NUMBER';

// Fetch later in step 2
export const SENDER_POI = 'pickUpPOI';
export const DROP_OFF_POI = 'dropOffPOI';

export const KEY_ROW_INDEX = 3;
export const DATA_SHEET_NAME = 'Data';
export const MAX_TEMPLATE_ROW = 150;

export const PARSE_EXCEL_ERROR_CODE = {
  TEMPLATE_ERROR: 1,
  INVALID_DATA_ERROR: 2,
  EMPTY_DATA_ERROR: 3,
  FILE_SIZE_ERROR: 4,
  REQUIRED_DATA_ERROR: 5,
  EXCEED_BOOKING_LIMIT_ERROR: 6,
  MULTISTOP_VALIDATION_ERROR: 7,
  NOT_FOUND_WORK_SHEET: 8,
};

export const getUploadSpreadsheetDataArea = () => ({
  labelRow: 3,
  dataRow: 4,
});

export const MAX_EXCEL_SIZE = 5000000; //5MB

// If user have more than 20 orders recently, show bulk budge on-boarding
export const SHOW_NUDGE_BULK_UPLOAD_ORDERS = 20;

// Step 3 table view
export const MAX_ADD_ON_NAME_LENGTH = 5;

// Default worksheet suffix name to parse
export const DEFAULT_XLSX_WORK_SHEET_SUFFIX = 'Template';

export const DATA_WORKSHEET_COL = {
  ParcelTypes: "A",
  VehicleTypes: "B",
  ServiceTypes: "C",
  ItemWeights: "D",
  AdminAreas: "E",
  ParcelSizes: "F",
}
